module.exports = __webpack_public_path__ + "57115782365e14f7fff57ca0747dfa66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/partnerlogos/ucsf-smokefreemovies-logo.png
// module id = 1987
// module chunks = 0